import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';
import {
  useGetPatientChallengeContentByContentId,
  useGetChallengeReport,
  useGetAllSubmissionByContentIdAndDate,
} from '_api';
import { DateRangeSelector, ReportChart } from 'components/organisms';
import { ActivitySubmission } from 'components/organisms/modals/ActivitySubmission';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { IoMdArrowBack } from 'react-icons/io';

import { ReportViewProps } from './types';

export const ChallengeReport = ({ id }: ReportViewProps) => {
  const theme = useTheme();
  const { data: challengeContent, isFetching: loadingContent } =
    useGetPatientChallengeContentByContentId(id);
  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
  });
  const {
    data: challengeReport,
    isFetching,
    isFetched,
    refetch,
  } = useGetChallengeReport(id, dateRange.startDate, dateRange.endDate);

  const [showNotes, setShowNotes] = useState(false);

  const { data: activitySubmissionNotes, isLoading: isLoadingNotes } =
    useGetAllSubmissionByContentIdAndDate(id);

  useEffect(() => {
    if (!isFetching) refetch();
  }, [dateRange]);

  const handleRangeChange = ({
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  }) => {
    setDateRange({ startDate, endDate });
  };

  if (!challengeReport && !isFetching) {
    return <Typography variant="h6">Challenge Report Not Found...</Typography>;
  }

  const handleBack = () => {
    history.back();
  };

  var assignedDate = challengeContent?.schedules[0].startDate;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', paddingTop: '50px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ marginTop: '10px', color: `${theme.palette.primary.main}` }}>
          <IoMdArrowBack />
        </Box>
        <Button onClick={handleBack} sx={{ justifyContent: 'left' }}>
          {' '}
          Back{' '}
        </Button>
      </Box>
      <Typography variant={'h3'} gutterBottom>
        {challengeContent ? challengeContent.content.title : ''}
      </Typography>
      {challengeReport !== undefined && !loadingContent && isFetched ? (
        <Box>
          <DateRangeSelector onChange={handleRangeChange} onNotesClick={setShowNotes} />
          {!showNotes && challengeReport ? (
            <ReportChart
              assignedDate={assignedDate}
              schedules={challengeContent?.schedules ?? []}
              endDate={dateRange.endDate}
              report={challengeReport}
              startDate={dateRange.startDate}
              xAxisLabel={'Date'}
              completedDate={challengeContent?.completedDate}
            />
          ) : !isLoadingNotes && activitySubmissionNotes ? (
            <ActivitySubmission data={activitySubmissionNotes} />
          ) : (
            <CircularProgress size={60} />
          )}
        </Box>
      ) : (
        <Box sx={{ margin: 'auto' }}>
          <CircularProgress size={60} />
        </Box>
      )}
    </Box>
  );
};
